module.exports = __webpack_public_path__ + "img/makiimsetohnehintergrund.fa37b7d7.png";